//
//  https://material.angular.io/guide/getting-started
//

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatMomentDateModule } from '@angular/material-moment-adapter';

/* Date formats: https://material.angular.io/components/datepicker/overview */
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';


export const CUSTOM_DATE_FORMATS = {
    parse: {
        dateInput: 'DD/MM/YYYY'
    },
    display: {
        dateInput: 'DD/MM/YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY'
    },
};


const toExportModules: any[] = [
    MatDatepickerModule,
    MatIconModule,
    MatMomentDateModule,
];

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        ...toExportModules,

    ],
    exports: [
        ...toExportModules,
    ],
    providers: [
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
        // { provide: MAT_DATE_LOCALE, useValue: 'pl' } /* This will enable local lang */
    ],
})
export class MaterialModule { }
